// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-estimates[data-v-bdf676a6]{min-height:50px;position:relative}.payment-estimates__loading-overlay[data-v-bdf676a6]{background:rgba(0,0,0,.1);position:absolute;left:0;top:0;height:100%;width:100%}.payment-estimates__loading-spinner[data-v-bdf676a6]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:50px;z-index:1}", ""]);
// Exports
module.exports = exports;
